import { render, staticRenderFns } from "./KnFinancialVarPromptPaymentDiscounts.vue?vue&type=template&id=03c61f78&"
import script from "./KnFinancialVarPromptPaymentDiscounts.vue?vue&type=script&lang=js&"
export * from "./KnFinancialVarPromptPaymentDiscounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports